import { render, staticRenderFns } from "./WflowCcMe.vue?vue&type=template&id=81015b2a"
import script from "./WflowCcMe.vue?vue&type=script&lang=js"
export * from "./WflowCcMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports